









































import { Vue, Component } from "vue-property-decorator";
import { ResetPwd } from "@/interface/login";
import { forgetPwd, getQrCode } from "@/http/login.api";

@Component
export default class Login extends Vue {
  validateQr(rule: any, value: any, callback: Function) {
    if (!value) {
      return callback("请填写验证码");
    } else {
      callback();
    }
  }
  validatePwd(rule: any, value: any, callback: Function) {
    const len = this.form.password.length;
    if (len > 14 || len < 8) {
      return callback("密码长度在8-14位之间");
    } else {
      callback();
    }
  }
  form: ResetPwd = {
    password: "",
    mobile: "",
    verCode: ""
  };
  rules = {
    mobile: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
    verCode: [{ validator: this.validateQr, trigger: "blur" }],
    password: [{ validator: this.validatePwd, trigger: "blur" }]
  };
  async onSubmit() {
    const ref = this.$refs.resetPwd as any;
    const valid = await ref.validate();
    if (!valid) return;
    const data = await forgetPwd(this.form);
    await this.$alert("找回密码成功", "找回密码", {
      type: "success"
    });
    this.$router.push("/login");
  }
  get qrName() {
    return this.qrCodeIsSend ? `已发送(${this.time}s)` : "发送验证码";
  }
  qrCodeIsSend = false;
  time = 60;
  async handleQrCodeClick() {
    const { mobile } = this.form;
    await getQrCode(mobile);
    this.qrCodeIsSend = true;
    const timer = setInterval(() => {
      this.time -= 1;
      if (this.time === 0) {
        this.qrCodeIsSend = false;
        this.time = 60;
        clearInterval(timer);
      }
    }, 1000);
  }
}
